import { FactorType, type SelfServiceLandingPageDataResponse } from '../../api/types';
import { SELF_SERVICE_TIMEOUT } from '@portal/constants';

export const isFaceEnabled = (landingPageData?: SelfServiceLandingPageDataResponse) => {
  const faceEnrollmentComplete = landingPageData?.authenticators.find(
    el => el.factorType === FactorType.FACE,
  );
  const hasImprivataIdentity = landingPageData?.userInfo.userId;
  const isFaceEntitlementEnabled = landingPageData?.enabledFactors.includes(FactorType.FACE);

  return !faceEnrollmentComplete && hasImprivataIdentity && isFaceEntitlementEnabled;
};

// windowCloseSec is caller-supplied (URL query param) and must not extend the idle
// timeout beyond SELF_SERVICE_TIMEOUT; it can only shorten it.
export const determineWindowCloseTimeoutMins = (windowCloseSec: string | null): number => {
  const parsedSeconds = Number(windowCloseSec);
  return Number.isFinite(parsedSeconds) && parsedSeconds > 0
    ? Math.min(parsedSeconds / 60, SELF_SERVICE_TIMEOUT)
    : SELF_SERVICE_TIMEOUT;
};
